// extracted by mini-css-extract-plugin
module.exports = {"header":"PublicHeader_header__2bp0a","logoImg":"PublicHeader_logoImg__RMcT0"};